const _ = require('lodash');

const SearchPhraseActionService = function SearchPhraseActionService(Restangular, $state, loginService, shopperService, $window, moveFocus, $q, bootstrap, searchMultisearchService, searchService) {
    this._api = Restangular.one('Search');
    this._state = $state;
    this._window = $window;
    this._q = $q;
    this.loginService = loginService;
    this.shopper = shopperService;
    this.multisearchService = searchMultisearchService;
    this.searchService = searchService;
    this._moveFocus = moveFocus;

    this.action = {
        login: 'PromptLogin',
        navigate: 'GoToUrl',
    };

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SearchPhraseActions)) {
        this._setSearchPhraseActions.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SearchPhraseActions));
    }
};

SearchPhraseActionService.prototype._setSearchPhraseActions = function (searchPhraseActions) {
    this.searchPhraseActions = _.keyBy(searchPhraseActions.SearchPhraseActions, searchPhraseAction => searchPhraseAction.Phrase.toLowerCase());
};

SearchPhraseActionService.prototype.getSearchPhraseAction = function (searchTerm) {
    if (this.searchPhraseActions) {
        return this._q.when(searchTerm.toLowerCase() in this.searchPhraseActions && this.searchPhraseActions[searchTerm.toLowerCase()]);
    }

    return this._api.one('SearchPhraseAction').get({
        SearchTerm: searchTerm,
    });
};

SearchPhraseActionService.prototype.actionPromptsForLogin = function (searchPhraseAction) {
    return searchPhraseAction.Action === this.action.login && this.shopper.IsGuest;
};

SearchPhraseActionService.prototype.performSearchPhraseAction = function (searchPhraseAction) {
    return this._q((resolve, reject) => {
        if (this.actionPromptsForLogin(searchPhraseAction)) {
            this._moveFocus('#loginForm-Email');
            return this.loginService.promptForLogin(this.loginService.LoginToContinueMessage).then(resolve);
        } else if (searchPhraseAction.Action === this.action.navigate) {
            if (searchPhraseAction.Target === 'Blank') {
                this._state.go('shop.search.external-result', { searchTerm: searchPhraseAction.Phrase }, { inherit: false });
                this._window.open(searchPhraseAction.URL, '_blank');
            } else {
                this._window.location.href = searchPhraseAction.URL;
            }
            return reject();
        }
        return resolve();
    });
};

SearchPhraseActionService.prototype.searchRequiresLogin = function (searchPhrase) {
    return this._q((resolve) => {
        if (!searchPhrase || searchPhrase === '') {
            resolve(false);
        }
        this.getSearchPhraseAction(searchPhrase).then((action) => {
            if (action) {
                resolve(this.actionPromptsForLogin(action) && !this.multisearchService.isSearchMultisearch());
            }
            resolve(false);
        });
    });
};

module.exports = SearchPhraseActionService;



// WEBPACK FOOTER //
// ./src/search/search-phrase-action.service.js